"use client";

import { ThemeProvider, useTheme } from "next-themes";
import { useEffect } from "react";
import { getCookie } from "cookies-next";
import PlatformsThemeProviderClient from "@/components/package-components/layout/PlatformsThemeProviderClient";

interface ProvidersProps {
  children: React.ReactNode;
  props: any;
}

export function Providers({ children, props }: ProvidersProps) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      themes={["light", "dark"]}
    >
      <InnerThemeSync />
      <PlatformsThemeProviderClient settings={props}>
        {children}
      </PlatformsThemeProviderClient>
    </ThemeProvider>
  );
}

function InnerThemeSync() {
  const { setTheme } = useTheme();

  useEffect(() => {
    const cookieTheme = getCookie("theme") as string | undefined;

    if (cookieTheme === "light" || cookieTheme === "dark") {
      setTheme(cookieTheme);
    }
  }, [setTheme]);

  return null;
}
